<div class="loader-container" [class.bg]="showBg" [ngClass]="[position]">
  <div class="loader" [ngStyle]="{ width: size, height: size }"></div>
</div>
